import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import CommentBox from '../contracting/generic-components/comment-box';
import { sendMessage } from './store/actions';
import injectSheet from 'react-jss';

const styles = {
  commentBox: {
    backgroundColor: 'white',
    marginBottom: '3px',
  },
};

class Comment extends Component {
  constructor(props) {
    super(props);
    this.defaultState = { // don't include object in values
      currentComment: '',
      disableSend: false,
      attachedFiles: [],
    };
    this.state = Object.assign({}, this.defaultState);
  }
  componentWillReceiveProps(newProps) {
    if (newProps.messageCreating && !this.state.disableSend) {
      // sending to server
      this.setState({ disableSend: true });
    }
    if (!newProps.messageCreating && this.state.disableSend) {
      // message has been sent !
      this.setState({ disableSend: false });
      if (!newProps.messageCreateError) {
        // and no error, wow
        this.setState(this.defaultState);
        this.clearInput();
      }
    }
  }
  handleComment = (input) => {
    this.setState({ currentComment: input });
  }
  handleCancel = () => {
    this.setState({ currentComment: '', attachedFiles: [] });
    this.setState({ disableSend: false });
    this.clearInput();
  }
  submitComment = () => {
    this.setState({ disableSend: true }, () => {
      this.props.sendMessage({
        messageText: this.state.currentComment,
        files: this.state.attachedFiles,
      });
    });
  }
  handleAttachFile = (fileList) => {
    this.setState({ attachedFiles: fileList });
  }

  render() {
    return (
      <CommentBox
        comment={this.state.currentComment}
        handleInput={this.handleComment}
        attachFile={this.handleAttachFile}
        attachedFiles={this.state.attachedFiles}
        submitComment={this.submitComment}
        cancelComment={this.handleCancel}
        disableSend={this.state.disableSend}
        className={this.props.classes.commentBox}
        setClear={clear => this.clearInput = clear}
        {...(this.props.internal ? { internal: true } : {})}
      />
    );
  }
}
Comment.propTypes = {
  selectedChannel: PropTypes.string,
  sendMessage: PropTypes.func,
  messageCreating: PropTypes.bool,
  messageCreateError: PropTypes.bool,
  classes: PropTypes.object,
  internal: PropTypes.bool,
};

Comment.defaultProps = {
  internal: false,
};

const select = (state) => ({
  selectedChannel: state.workspace.selectedChannel,
  messageCreating: state.workspace.messageCreating,
  messageCreateError: state.workspace.messageCreateError,
});

export default connect(select, { sendMessage })(injectSheet(styles)(Comment));



// WEBPACK FOOTER //
// ./src/app/components/workspace/content-comment.jsx